export interface BannerData {
  id: number;
  title: string;
  subtitle: string;
  imageUrl: string;
  imageAlt: string;
}

export const bannerDataList: BannerData[] = [
  {
    id: 1,
    title: '이불 밖은 더 아플 때',
    subtitle: '병원에서 전화가 와요',
    imageUrl: 'https://media.doctornow.co.kr/home_main_banner_sick_in_bed.webp',
    imageAlt: '침대에서 아픈 환자가 휴식을 취하는 모습',
  },
  {
    id: 2,
    title: '바빠서 꼼짝 못할 때',
    subtitle: '병원에서 전화가 와요',
    imageUrl: 'https://media.doctornow.co.kr/home_main_banner_busy_office.webp',
    imageAlt: '바쁜 업무 중인 직장인이 스트레스를 받는 모습',
  },
  {
    id: 3,
    title: '먹던 약 떨어졌을 때',
    subtitle: '병원에서 전화가 와요',
    imageUrl: 'https://media.doctornow.co.kr/home_main_banner_medicine_hand.webp',
    imageAlt: '손에 약을 들고 있는 모습',
  },
  {
    id: 4,
    title: '소아과 대기가 길 때',
    subtitle: '병원에서 전화가 와요',
    imageUrl: 'https://media.doctornow.co.kr/home_main_banner_pediatric_clinic.webp',
    imageAlt: '소아과 진료실에서 아이와 의료진이 있는 모습',
  },
];
